export default __webpack_public_path__ + "static/media/ht-baby.f0a70a51.png";